export class AttedanceCalendarModel
{
    public AttendanceDate : Date;
    public InTime : Date;
    public OutTime : Date;
    public WorkingDurationInMinutes : number;
    public Remarks : string;
    public AttendanceStatus : string;
    public AttendanceColor : string;
}